var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelineIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 13.6668H4.66671C2.66671 13.6668 1.33337 12.6668 1.33337 10.3335V5.66683C1.33337 3.3335 2.66671 2.3335 4.66671 2.3335H11.3334C13.3334 2.3335 14.6667 3.3335 14.6667 5.66683V10.3335C14.6667 12.6668 13.3334 13.6668 11.3334 13.6668Z",
    stroke: "#465273",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 6L9.24662 7.66667C8.55996 8.21333 7.43329 8.21333 6.74662 7.66667L4.66663 6",
    stroke: "#465273",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineIconEmail);
export default __webpack_public_path__ + "static/media/pipeline_icon_email.ecacbef59fca1f498ca80abfdf51109c.svg";
export { ForwardRef as ReactComponent };